import { render, staticRenderFns } from "./allStocks.vue?vue&type=template&id=14c589fa&"
import script from "./allStocks.vue?vue&type=script&lang=js&"
export * from "./allStocks.vue?vue&type=script&lang=js&"
import style0 from "./allStocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports